export default "__VITE_ASSET__3nl0NDGe__"